var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.408857 19.018C0.0807518 18.8672 -0.00631651 18.6079 7.83344e-05 18.2592C0.0655025 14.8817 2.65 11.8795 5.98762 11.3349C6.40378 11.2671 6.82977 11.2381 7.25232 11.2288C8.002 11.2126 8.75265 11.2018 9.50183 11.2293C12.3456 11.3339 14.4278 12.6781 15.7904 15.1425C16.3266 16.1125 16.5598 17.1719 16.6065 18.2769C16.6213 18.6212 16.517 18.8702 16.1987 19.0175H0.408857V19.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.323 5.15861C3.323 2.4206 5.56464 0.190898 8.31245 0.195809C11.0529 0.20072 13.2837 2.42698 13.2837 5.15812C13.2837 7.89613 11.0421 10.1263 8.29425 10.1214C5.5548 10.1165 3.323 7.88827 3.323 5.15861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6079,
    height: 18.8223,
    fill: "white",
    transform: "translate(0 0.196045)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaAccount);
export default __webpack_public_path__ + "static/media/icona-account.e48d3db2c9ddd767b568480b6375cebd.svg";
export { ForwardRef as ReactComponent };